<div class="input-form input-text date">
  <p-calendar
    (click)="lanzar($event)"
    [(ngModel)]="date"
    name="fecha"
    [maxDate]="maxDate"
    dateFormat="dd/MM/yy"
    [locale]="es"
    [showButtonBar]="true"
    [readonlyInput]="true"
    [required]="true"
  ></p-calendar>
  <span class="highlight"></span>
  <span class="bar"></span>
  <label
    *ngIf="date === null || date === undefined"
    for="fecha"
  >Fecha</label>
</div>
